import { throttle } from "./utilities/throttle";
import { debounce } from "./utilities/debounce";

const toggle = document.getElementById('navbar-toggle');
const offcanvas = document.getElementById('navbar-offcanvas');
const header = document.getElementById('osHeader');

if(toggle) {
  toggle.addEventListener('click', () => {
    offcanvas.classList.toggle('translate-x-full');
    toggle.classList.toggle('is-active');
    document.body.classList.toggle('is-offcanvas-active');
  });
}

const checkScrolling = () => {
  if(!header) return;

  if(window.scrollY > 10) {
    document.body.classList.add('is-scrolled');
  } else {
    document.body.classList.remove('is-scrolled');
  }

  if(window.scrollY > header.clientHeight) {
    document.body.classList.add('has-passed-header');
  } else {
    document.body.classList.remove('has-passed-header');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if(!header) return;

  const setHeaderHeight = () => {
    const wpadminbar = document.getElementById('wpadminbar');
    if (wpadminbar) {
      document.body.style.setProperty('--adminbar-height', `${wpadminbar.clientHeight/16}rem`);
    }

    document.body.style.setProperty('--global-header-height', `${header.clientHeight/16}rem`);
  };

  setHeaderHeight();
  checkScrolling(); // Run the scroll check on page load

  let lastWidth = window.innerWidth;
  window.addEventListener('resize', debounce(() => {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      setHeaderHeight();
    }
  }, 200));
},{ once:true })

window.addEventListener(
  'scroll',
  throttle(function () {
    checkScrolling();
  })
);

document.addEventListener("DOMContentLoaded", function () {
  function initCustomDatePicker() {
    document.body.addEventListener('focusin', function(event) {
      if (event.target && event.target.classList.contains('datepicker')) {
        var inputElement = event.target;
        var today = new Date();

        if (inputElement._flatpickr) {
          inputElement._flatpickr.set("minDate", today);
        }

        var siblingHiddenInput = inputElement.parentElement ? inputElement.parentElement.querySelector('input[type="hidden"]') : null;
        if (siblingHiddenInput && siblingHiddenInput._flatpickr) {
          siblingHiddenInput._flatpickr.set("minDate", today);
        }

        setTimeout(function() {
          if (inputElement._flatpickr) {
            inputElement._flatpickr.set("minDate", today);
          }
          if (siblingHiddenInput && siblingHiddenInput._flatpickr) {
            siblingHiddenInput._flatpickr.set("minDate", today);
          }
        }, 80);
      }
    });
  }

  if (document.querySelector(".ninja-lit-ordering")) {
    initCustomDatePicker();
  } else {
    var observer = new MutationObserver(function (mutations, observerInstance) {
      if (document.querySelector(".ninja-lit-ordering")) {
        initCustomDatePicker();
        observerInstance.disconnect(); // Stop observing once the form matches
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});
